export const createSegmenter = (): Intl.Segmenter | null => {
	try {
		return Intl?.Segmenter ? new Intl.Segmenter(undefined, { granularity: 'word' }) : null;
	} catch {
		return null;
	}
};
